import { useState } from 'react'

export default function useNavigatorPermissionsQuery(query) {
    const [status, setStatus] = useState(null)
    function refreshStatus() {
        navigator?.permissions?.query(query)?.then(setStatus)
    }
    return { status, refreshStatus }
}
